import { render, staticRenderFns } from "../../../pages/physician/custom/custom.html?vue&type=template&id=015ee97e&scoped=true&"
import script from "../../../pages/physician/custom/custom.js?vue&type=script&lang=js&"
export * from "../../../pages/physician/custom/custom.js?vue&type=script&lang=js&"
import style0 from "../../../pages/physician/custom/custom.css?vue&type=style&index=0&id=015ee97e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015ee97e",
  null
  
)

export default component.exports